let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kD057")).then(() => parcelRequire('KcDfp'));